// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"15a9327e","57":"5e9307fa","139":"508eab6e","252":"ba6c6457","368":"369e2b1b","559":"5b6b96f6","560":"ffc9b4ef","580":"b40ed59d","651":"8334e53a","757":"018da31a","772":"68150e95","784":"22b94a18","787":"8517a1b9","925":"d11d0e42","974":"bd4dc252"}[chunkId] + ".chunk.js";
};